class CustomSwiper extends Swiper {
  constructor(element, options = {}) {
    let scrollY = 0;
    let locked = false;
    let touching = false;

    const lockScroll = () => {
      if (locked) return;
      locked = true;
      scrollY = window.scrollY;
      document.body.style.overflow = 'hidden';
    };

    const unlockScroll = () => {
      if (!locked) return;
      locked = false;
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    };

    const baseHandlers = {
      touchStart() {
        touching = true;
      },
      sliderFirstMove() {
        lockScroll();
      },
      touchEnd(swiper) {
        touching = false;
        if (!swiper.animating) unlockScroll();
      },
      touchCancel() {
        touching = false;
        unlockScroll();
      },
      transitionEnd() {
        if (!touching) unlockScroll();
      },
      destroy() {
        unlockScroll();
      },
    };

    const mergedOn = { ...(options.on || {}) };

    Object.keys(baseHandlers).forEach((eventName) => {
      const baseHandler = baseHandlers[eventName];
      const userHandler = mergedOn[eventName];

      if (typeof userHandler === 'function') {
        mergedOn[eventName] = function (...args) {
          baseHandler.apply(this, args);
          userHandler.apply(this, args);
        };
      } else {
        mergedOn[eventName] = baseHandler;
      }
    });

    super(element, {
      ...options,
      on: mergedOn,
    });
  }
}